import { useEffect, useState } from 'react';

export const HUB_NAME = 'Sport Intelligence';
export const AREA_PATH = { hub: '/hub', access: '/access', 'ai-services':'/ai-services', racing: '/racing', league: '/nrl', union: '/rugby-union' };
export const AREA_NAME = { hub: 'Hub', access: 'Access management', 'ai-services':'AI Services', racing: 'Horse Racing', league: 'NRL', union: 'Rugby Union & Sevens' };
const SEGMENT_AREA = { hub: 'hub', access: 'access', 'ai-services':'ai-services', racing: 'racing', nrl: 'league', league: 'league', 'rugby-union': 'union', union: 'union' };
const decode = value => { try { return decodeURIComponent(value); } catch { return ''; } };

export function readRoute(location = window.location) {
  const q = new URLSearchParams(location.search), parts = location.pathname.split('/').filter(Boolean).map(decode);
  const r = { area: 'hub', view: 'default', at: Number(q.get('at')) || 0, from: q.get('from') || null };
  if (!parts.length) {
    r.area = q.get('view') === 'access' ? 'access' : q.get('view') === 'hub' ? 'hub' : q.get('ws') || (q.has('race') || q.has('view') ? 'racing' : 'hub');
    r.view = q.get('view') || (q.has('clip') ? 'review' : 'default');
    r.race = q.get('race'); r.clip = q.get('clip'); r.report = q.get('report'); r.dash = q.get('dash') === '1'; r.share = q.get('s');
    if (r.race?.startsWith('lab-')) { r.report = r.race.slice(4); r.race = null; r.view = 'lab'; r.dash = true; }
    if (q.get('present') === '1' && ['racing','league','union'].includes(r.area)) { r.view = 'showcase'; r.item = r.area === 'racing' ? r.report ? `lab-${r.report}` : r.race : r.clip ? `rugby-${r.clip}` : null; }
  } else if (parts[0] === 'share' && parts.length === 2) {
    r.share = parts[1];
  } else {
    r.area = SEGMENT_AREA[parts[0]] || 'not-found';
    const [,, id, detail] = parts;
    if (parts.length > 1) {
      if (parts[1] === 'showcase' && ['racing','league','union'].includes(r.area) && parts.length <= 3) { r.view = 'showcase'; r.item = id || null; }
      else if (parts[1] === 'races' && r.area === 'racing' && id && parts.length === 3) { r.race = id; r.view = 'race'; }
      else if (parts[1] === 'clips' && ['league','union'].includes(r.area) && id && parts.length === 3) { r.clip = id; r.view = 'review'; }
      else if (parts[1] === 'insights' && ['racing','union'].includes(r.area) && (r.area==='racing'?parts.length<=4:parts.length===2) && (!detail || detail === 'dashboard')) { r.view = 'lab'; r.report = id || null; r.dash = detail === 'dashboard'; }
      else if (parts[1] === 'trends' && r.area === 'racing' && parts.length === 2) r.view = 'trends';
      else if (['library','profiles'].includes(parts[1]) && ['league','union'].includes(r.area) && parts.length === 2) r.view = parts[1];
      else r.area = 'not-found';
    }
  }
  if (!AREA_PATH[r.area] && r.area !== 'not-found') r.area = 'not-found';
  return r;
}

export function routeUrl(r) {
  if (r.share) return `/share/${encodeURIComponent(r.share)}`;
  let path = AREA_PATH[r.area] || '/not-found';
  if (r.view === 'showcase') path += `/showcase${r.item ? `/${encodeURIComponent(r.item)}` : ''}`;
  else if (r.area === 'racing') {
    if (r.view === 'trends') path += '/trends';
    else if (r.view === 'lab') path += `/insights${r.report ? `/${encodeURIComponent(r.report)}${r.dash ? '/dashboard' : ''}` : ''}`;
    else if (r.race) path += `/races/${encodeURIComponent(r.race)}`;
  } else if (['league','union'].includes(r.area)) {
    if (r.clip) path += `/clips/${encodeURIComponent(r.clip)}`;
    else if (r.view === 'lab') path += '/insights';
    else if (['library','profiles'].includes(r.view)) path += `/${r.view}`;
  }
  const query = new URLSearchParams();
  if (r.at > 0 && Number.isFinite(r.at)) query.set('at', r.at);
  if (['lab','profiles'].includes(r.from)) query.set('from', r.from);
  // URLSearchParams.size is absent in older browsers and Jest's DOM runtime.
  const search = query.toString();
  return path + (search ? `?${search}` : '');
}

export function navigateRoute(route, replace = false) {
  const url = routeUrl(route);
  if (window.location.pathname + window.location.search === url) return;
  window.history[replace ? 'replaceState' : 'pushState'](null, '', url);
  window.dispatchEvent(new Event('app-route-change'));
}

export function useAppRoute() {
  const [route, setRoute] = useState(readRoute);
  useEffect(() => {
    const update = () => setRoute(readRoute());
    window.addEventListener('popstate', update); window.addEventListener('app-route-change', update);
    return () => { window.removeEventListener('popstate', update); window.removeEventListener('app-route-change', update); };
  }, []);
  return route;
}

export function pageTitle(route, mode) {
  if (route.area === 'not-found') return `Page not found | ${HUB_NAME}`;
  if (route.share) return `Shared access | ${HUB_NAME}`;
  if (route.area === 'hub') return `${HUB_NAME} | DD Sports Intelligence Hub`;
  const section = mode === 'presenter' || route.view === 'showcase' ? 'Showcase' : ({ lab: 'Insights Lab', trends: 'Race Trends', profiles: 'Team Profiles', library: 'Clip Library', review: 'Match Review' })[route.view];
  return [section, AREA_NAME[route.area], HUB_NAME].filter(Boolean).join(' | ');
}